var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('documents-card',{attrs:{"documents":_vm.bookmarks,"title":"Je favoriete artikelen"}})}
var staticRenderFns = []

export { render, staticRenderFns }